export default {
  contact: {
    title: '@:contact_section.card_title',
  },
}
